/**
 * Article List Pagination
 * Handles dynamic pagination for article list component
 * Supports different items-per-page for desktop and mobile
 */

class ArticleListPagination {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('.article-grid');
    this.articles = Array.from(this.grid.querySelectorAll('.article-card'));
    this.totalArticles = this.articles.length;
    
    this.paginationContainer = section.querySelector('.article-pagination');
    if (!this.paginationContainer) return;
    
    this.prevButton = this.paginationContainer.querySelector('.pagination-button--prev');
    this.nextButton = this.paginationContainer.querySelector('.pagination-button--next');
    this.currentPageSpan = this.paginationContainer.querySelector('.current-page');
    this.totalPagesSpan = this.paginationContainer.querySelector('.total-pages');
    
    this.desktopPerPage = parseInt(section.dataset.desktopPerPage) || 6;
    this.mobilePerPage = parseInt(section.dataset.mobilePerPage) || 3;
    
    this.currentPage = 1;
    this.isMobile = window.innerWidth <= 699;
    
    this.init();
  }
  
  init() {
    if (this.totalArticles === 0) return;
    
    // 设置初始状态
    this.updatePagination();
    
    // 绑定事件
    this.bindEvents();
    
    // 监听窗口大小变化
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 699;
        
        // 如果设备类型改变,重置到第一页
        if (wasMobile !== this.isMobile) {
          this.currentPage = 1;
          this.updatePagination();
        }
      }, 150);
    });
  }
  
  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.goToPreviousPage());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goToNextPage());
    }
  }
  
  get itemsPerPage() {
    return this.isMobile ? this.mobilePerPage : this.desktopPerPage;
  }
  
  get totalPages() {
    return Math.ceil(this.totalArticles / this.itemsPerPage);
  }
  
  updatePagination() {
    const totalPages = this.totalPages;
    
    // 显示/隐藏文章
    this.showArticlesForCurrentPage();
    
    // 更新页码显示
    if (this.currentPageSpan) {
      this.currentPageSpan.textContent = this.currentPage;
    }
    if (this.totalPagesSpan) {
      this.totalPagesSpan.textContent = totalPages;
    }
    
    // 更新按钮状态
    if (this.prevButton) {
      this.prevButton.disabled = this.currentPage === 1;
    }
    if (this.nextButton) {
      this.nextButton.disabled = this.currentPage >= totalPages;
    }
    
    // 如果只有一页,隐藏分页
    if (this.paginationContainer) {
      if (totalPages <= 1) {
        this.paginationContainer.style.display = 'none';
      } else {
        this.paginationContainer.style.display = '';
      }
    }
  }
  
  showArticlesForCurrentPage() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    
    this.articles.forEach((article, index) => {
      if (index >= startIndex && index < endIndex) {
        article.style.display = '';
        // 添加淡入动画
        article.style.animation = 'fadeIn 0.3s ease-in';
      } else {
        article.style.display = 'none';
      }
    });
    
    // 滚动到顶部
    this.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  
  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }
  
  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }
}

// 初始化所有文章列表分页
document.addEventListener('DOMContentLoaded', () => {
  const articleListSections = document.querySelectorAll('.article-list-section');
  articleListSections.forEach(section => {
    new ArticleListPagination(section);
  });
});

// 添加淡入动画
if (!document.querySelector('#article-pagination-styles')) {
  const style = document.createElement('style');
  style.id = 'article-pagination-styles';
  style.textContent = `
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);
}
